/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-entity-tree-header',
    templateUrl: './entity-tree-header.component.html',
    styleUrls: ['./entity-tree-header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EntityTreeHeaderComponent {
}
